import { createSelector} from '@ngrx/store';
import {AppState} from '../app.model';

export const selectRequests = (state: AppState) => state.requests;

export const selectRequestsPendingRequests = createSelector(
    selectRequests,
    (requests) => requests.pendingRequests
);

export const selectAnyRequestsPendingRequests = createSelector(
    selectRequests,
    (requests) => requests.pendingRequests > 0
);